// extracted by mini-css-extract-plugin
module.exports = {"payButton":"PaymentFooter_payButton__2qhz1"};